import React from "react";
import { TouchableOpacity } from "./react-native";
import { XIcon } from "@shopify/polaris-icons";
import { Icon } from "@shopify/polaris";

export default function ExitButton({ onPress, position = "absolute" }) {
  return (
    <TouchableOpacity style={{ position: position, top: 10, right: 10, width: 50, height: 50 }} onPress={onPress}>
      <Icon source={XIcon} />
    </TouchableOpacity>
  );
}
